import { useEffect, useState } from "react";
import "./UserProfileCard.css";
import PersonIcon from "@mui/icons-material/Person";
import UploadPhotoButton from "./UploadPhotoButton";
import axiosClient from "@service/axiosClient";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import PTOBankBalanceDialog from "../pto_dash/PTOBankBalanceDialog";

const UserProfileCard = ({ prop, isAuthorized = true }) => {
  const { t } = useTranslation();
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [showPTOBalanceDialog, setShowPTOBalanceDialog] = useState(false);
  const [userData, setUserData] = useState({
    fullName: t("userProfile.noName"),
    plantName: t("userProfile.noPlant"),
    location: t("userProfile.noLocation"),
    contractorId: t("userProfile.noContractorId"),
  });

  // Logging the entire prop to confirm structure
  // console.log("Received prop in UserProfileCard:", prop);

  // This useEffect updates userData when prop changes
  useEffect(() => {
    // console.log("Updating userData with prop:", prop);
    if (prop && prop.worker) {
      setUserData({
        fullName: prop.full_name || t("userProfile.noName"),
        plantName: prop.worker.plant_name || t("userProfile.noPlant"),
        location: prop.worker.location || t("userProfile.noLocation"),
        contractorId:
          prop.worker.contractor_id || t("userProfile.noContractorId"),
      });
    }
  }, [prop, t]);

  const handleUploadSuccess = (newImageUrl) => {
    setProfileImageUrl(newImageUrl);
    // console.log("Profile image URL set to:", newImageUrl); // Debugging log
  };

  // Fetch profile image separately when user ID changes
  useEffect(() => {
    if (prop.id) {
      // console.log("Fetching profile image for user ID:", prop.id);
      axiosClient
        .get("/file/profile-image", {
          params: { user_id: prop.id },
        })
        .then((response) => {
          setProfileImageUrl(response.data.user_image_url);
          // console.log("Profile image URL fetched:", response.data.user_image_url); // Debugging log
        })
        .catch((error) => {
          console.error("Failed to fetch profile image:", error);
        });
    }
  }, [prop.id]);

  const handleOpenPTOBalance = () => {
    setShowPTOBalanceDialog(true);
  };

  const handleClosePTOBalance = () => {
    setShowPTOBalanceDialog(false);
  };

  // Render "Loading" text until data is available
  // if (!prop || !prop.id) {
  //     return <div>Loading user data...</div>;
  // }
  return (
    <div className="upc">
      <div className="gradient"></div>
      <div className="profile-down">
        <div className="profile-image-container">
          {profileImageUrl ? (
            <img
              src={profileImageUrl}
              alt="Profile"
              className="profile-image"
            />
          ) : (
            <PersonIcon className="profile-image" />
          )}
          {isAuthorized && (
            <UploadPhotoButton
              onUploadSuccess={handleUploadSuccess}
              userId={prop.id}
            />
          )}
        </div>
        <div className="profile-title"></div>
        <div className="profile-description">
          <h3>{userData.fullName}</h3>
          <p>
            {t("userProfile.plant")}: {userData.plantName}
          </p>
          <p>
            {t("userProfile.location")}: {userData.location}
          </p>
          <p>
            {t("userProfile.contractorId")}: {userData.contractorId}
          </p>
        </div>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 1 }}>
          {prop.worker && prop.worker.id && (
            <>
              <Button
                component={Link}
                to={`/contractor/${prop.worker.id}/statement-history`}
                variant="contained"
                startIcon={<HistoryOutlinedIcon />}
              >
                {t("userProfile.history")}
              </Button>
              <Button
                onClick={handleOpenPTOBalance}
                variant="contained"
                color="primary"
                startIcon={<AccountBalanceWalletIcon />}
              >
                {t("userProfile.ptoBalance")}
              </Button>
            </>
          )}
        </Box>
      </div>

      {/* PTO Bank Balance Dialog */}
      {showPTOBalanceDialog && prop.worker && (
        <PTOBankBalanceDialog
          workerId={prop.worker.id}
          contractorName={userData.fullName}
          contractorId={userData.contractorId}
          isOpen={showPTOBalanceDialog}
          onClose={handleClosePTOBalance}
          isAdminView={isAuthorized}
        />
      )}
    </div>
  );
};

export default UserProfileCard;
